import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { budgetKeys } from "queries";
import {
  normalizeBudgetBenchmarkMeta,
  resolveBudgetBenchmarkMeta,
  type BudgetBenchmarkMeta,
} from "components/dashboard/body/projects/panels/budget/budgetBenchmarkDetails";
import { useAxios } from "../useAxios";

const ONE_HOUR_MS = 60 * 60 * 1000;

export const useBudgetBenchmarkMeta = (enabled = true) => {
  const axios = useAxios({ allResponse: false });

  const query = useQuery({
    queryKey: budgetKeys.budgetBenchmarkMeta(),
    queryFn: async (): Promise<BudgetBenchmarkMeta> => {
      const response = await axios.get<{ data: BudgetBenchmarkMeta }>(
        USER_API.getBudgetBenchmarkMeta()
      );
      const payload = response as unknown;
      if (payload && typeof payload === "object" && "methodology" in payload) {
        return normalizeBudgetBenchmarkMeta(payload as BudgetBenchmarkMeta);
      }
      if (payload && typeof payload === "object" && "data" in payload) {
        return normalizeBudgetBenchmarkMeta((payload as { data: BudgetBenchmarkMeta }).data);
      }
      throw new Error("Invalid budget benchmark meta response");
    },
    enabled,
    staleTime: ONE_HOUR_MS,
    refetchOnWindowFocus: false,
  });

  return {
    meta: resolveBudgetBenchmarkMeta(query.data),
    isLoading: query.isLoading,
    isError: query.isError,
    usingFallback: query.isError || !query.data,
  };
};
